import * as React from 'react';

import { ApplicationState } from '../../../../store';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { IncidentAndDamage } from '../../../../store/details/case/model';
import { StaticInformation } from '../../../custom/static-information';
import { connect } from 'react-redux';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import styles from './incident.module.css';

interface IncidentProps {
  readonly incident: IncidentAndDamage;
  readonly header: string;
}

interface PropsFromState {
  readonly currentLanguage: string;
}

type AllProps = IncidentProps & PropsFromState;

class Incident extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);
    this.localization = getI18n();
  }

  render() {
    if (Object.keys(this.props.incident).length === 0) {
      return null;
    }

    return (
      <div className={styles.container}>
        <h2>{this.localization.get(this.props.header)}</h2>
        <div className={styles.static}>
          <div className={styles.staticContent}>
            <StaticInformation
              translation='details.case.incident'
              headerText=''
              information={{
                'damageLossDate': this.localization.getFormatedDate(this.props.incident.damageLossDate, this.props.currentLanguage),
                'damageLossTime': this.props.incident.damageLossTime,
                'damageLossCategory': this.props.incident.damageLossCategory,
                'damageLossCause': this.props.incident.damageLossCause,
                'damageCauseDescription': this.props.incident.damageCauseDescription,
                'creator': this.props.incident.creator,
                'insurerHandlingPerson': this.props.incident.insurerHandlingPerson,
                'reportedToPolice': this.props.incident.reportedToPolice,
                'investigationOfficerName': this.props.incident.investigationOfficerName,
                'policeStation': this.props.incident.policeStation,
                'interventionFireBrigade': this.props.incident.interventionFireBrigade,
                'fireBrigadeStation': this.props.incident.fireBrigadeStation,
                'repairedByCustomer': this.props.incident.repairedByCustomer,
                'vatClient': this.props.incident.vatClient,
                'vatPercentage': this.props.incident.vatPercentage,
                'crimeReferenceNumber': this.props.incident.crimeReferenceNumber,
                'policeReportDate': this.props.incident.policeReportDate,
                'instructionText' : this.props.incident.instructionText,
                'remarks': this.props.incident.remarks,
              }} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ shared }: ApplicationState): PropsFromState => ({
  currentLanguage: shared.currentLanguage
});

export default connect(mapStateToProps)(Incident);
